/** Negative correlations keep their own hue; only their magnitude is ramped. */
export function negativeCellColor(val: number, grayscale?: boolean): string {
  const magnitude = Math.abs(val);
  if (grayscale) {
    const g = Math.round(200 - magnitude * 80);
    return `rgb(${g},${g},${g})`;
  }
  return `rgba(245,158,11,${0.1 + magnitude * 0.4})`;
}
